// extracted by mini-css-extract-plugin
export default {"sideBtn":"profilepopup_sideBtn__3TYsl","popup":"profilepopup_popup__FLx9N","arrowTop":"profilepopup_arrowTop__DG84K","popupWrapper":"profilepopup_popupWrapper__kW61z"};